<div class="h-full w-full" id="ais">
  <iframe height="100%" id="vesselfinder" name="vesselfinder" [src]="vesselFinderUrl" width="100%">
    Browser does not support embedded objects.<br/>
    Visit <a href="https://www.vesselfinder.com" target="_blank">https://www.vesselfinder.com</a> manually.
  </iframe>
</div>
